// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Loader, Text } from '@mantine/core';
import { useState } from 'react';
import ConfigOption from '../../../../Atoms/ConfigOption';
import FilePicker from '../../../../Atoms/FilePicker';
import { DocumentS } from '../../../Documents/DocumentS';
import { MixpanelS } from '../../../../Service/MixpanelS';
import { ConstantS } from '../../../../Service/ConstantS';
import GrayBox from '../../../../Atoms/GrayBox';

const SevdeskImportPane = () => {
  const [importingProducts, setImportingProducts] = useState(false);

  const importProducts = async (csvFile: File) => {
    setImportingProducts(true);
    await DocumentS.importProductsSevdesk(csvFile);
    MixpanelS.track(ConstantS.TrackingEvents.SevdeskEntitiesImported, { entityType: 'product' });
    setImportingProducts(false);
  };

  return (
    <GrayBox mt="xl">
      <ConfigOption
        title="Produkte/Service importieren"
        description="Importiere Deine Produkte/Services aus sevdesk, indem Du in sevdesk links und dann auf Exportieren oben rechts -> 'CSV (Excel)' klickst und diese Datei in bookitup hochlädst."
        rightSection={
          importingProducts ? (
            <Loader variant="dots" size="xl" />
          ) : (
            <FilePicker
              id="products"
              onSelectFile={importProducts}
              accept=".csv"
              label={
                <Text variant="link" color="blue" sx={{ cursor: 'pointer' }}>
                  Importieren
                </Text>
              }
            />
          )
        }
      />
    </GrayBox>
  );
};

export default SevdeskImportPane;
